<template>
	<div class="count flex-column flex-center">
		<div>{{value || value === 0 ? value : '-'}}</div>
		<p>{{name}}</p>
	</div>
</template>

<script>
	export default {
		name: 'viewListTotal',

		props: {
			name: String,
			value: [Number, String]
		}
	}
</script>

<style lang="stylus" scoped>
	.count {
		box-sizing: border-box;
		min-width: 1.5rem;
		height: .92rem;
		border: .01rem dashed #ddd;
		border-radius: .04rem;
		padding: 0 .14rem;
		font-size: .24rem;
		color: #777;
		background: #F9F9F9;

		div {
			margin-bottom: .12rem;
			font-size: .3rem;
			font-weight: 500;
			color: var(--color-main);
		}
	}
</style>
